/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

import type { LoginPageProps } from "./types";

export default CustomPlatform.select<() => React.FC<LoginPageProps>>({
  tv: () => require("./LoginPage.tv").default,
  default: () => require("./LoginPage").default,
})();
